import { useEffect, useState } from "react";

import PageContainer from "@components/layout/PageContainer";
import ProfileForm from "@components/forms/ProfileForm";
import { useParams } from "react-router-dom";
import { useAppSelector } from "@/store/hooks";
import { ONVO_TENANT_PAYMENT_TYPE_CODE } from "@utils/Constants";
import { TenantApi } from "@/api/TenantApi";

const Profile = () => {
  const params = useParams();
  const { id: suscriptionId } = params;
  const tenantData = useAppSelector(stage => stage.suscription.tenantData)
  const [editedTenantId, setEditedTenantId] = useState<string | undefined>();

  useEffect(() => {
    if (suscriptionId) {
      TenantApi.fetchTenantBySuscriptionId(suscriptionId)
        .then(tenant => setEditedTenantId(tenant?.owner ?? undefined))
        .catch(() => setEditedTenantId(undefined));
    }
  }, [suscriptionId]);

  const adminSuffix = editedTenantId
    ? `?tenantId=${editedTenantId}&suscriptionId=${suscriptionId}`
    : "";

  const buildHref = (base: string) => `${base}${adminSuffix}`;

  return (
    <PageContainer
      title="Perfil de Usuario"
      backUrl="/user/dashboard"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "userProfile",
          type: "submit",
          color: "success"
        }
      ]}
      secondaryActions={[
        {
          actionTitle: "API Externa",
          href: buildHref("/user/api")
        },
        {
          actionTitle: "Actividad Economicas",
          href: buildHref("/user/economy-activities")
        },
        {
          isVisible: tenantData?.tipoPago == ONVO_TENANT_PAYMENT_TYPE_CODE && !suscriptionId,
          actionTitle: "Administracion de Suscripcion",
          href: "/user/tenant-manage"
        },
        {
          actionTitle: "Cuentas Bancarias",
          href: buildHref("/user/bank-accounts")
        },
        {
          actionTitle: "Control de Acceso",
          href: buildHref("/user/acl")
        },
        {
          actionTitle: "Informacion Personalizada",
          href: buildHref("/user/custom-fields")
        },
        {
          actionTitle: "Manejo de Precios",
          href: buildHref("/user/price-management")
        },
        {
          actionTitle: "Monedas",
          href: buildHref("/user/currencies")
        },
        {
          actionTitle: "Operadores de Tarjeta",
          href: buildHref("/user/credit-operators")
        },
        {
          actionTitle: "Plantillas de Correo",
          href: buildHref("/user/email-templates")
        },
        {
          actionTitle: "Vendedores",
          href: buildHref("/user/salemen")
        },
        {
          actionTitle: "Zona de Clientes",
          href: buildHref("/user/client-zones")
        },
      ]}
    >
      <ProfileForm suscriptionId={suscriptionId} />
    </PageContainer>
  );
}

export default Profile;
